import {
    PictogramBeachSmall,
    PictogramBigBenSmall,
    PictogramCitySmall,
    PictogramCoastSmall,
    PictogramFerrisWheelSmall,
    PictogramHillSmall,
    PictogramHouseSmall,
    PictogramLikedSmall,
    PictogramRuralSmall
} from '@zoopla-eng/zds-components/pictograms';
import { PICTOGRAMS_REMOTE_SPRITE_URL } from '@zoopla/assets';
import { SeoLinkPictograms } from '../cms-seo.types';

export const PictogramsList = {
    'City - Yellow': (
        <PictogramCitySmall
            remoteSpriteUrl={PICTOGRAMS_REMOTE_SPRITE_URL}
            backgroundColor="graphicSellingLight"
        />
    ),
    'Coast - Grey': (
        <PictogramCoastSmall
            remoteSpriteUrl={PICTOGRAMS_REMOTE_SPRITE_URL}
            backgroundColor="graphicBackgroundAccentLight"
        />
    ),
    'Rural - Green': (
        <PictogramRuralSmall
            remoteSpriteUrl={PICTOGRAMS_REMOTE_SPRITE_URL}
            backgroundColor="graphicPriceLight"
        />
    ),
    'Big Ben - Brown': (
        <PictogramBigBenSmall
            remoteSpriteUrl={PICTOGRAMS_REMOTE_SPRITE_URL}
            backgroundColor="graphicImprovingLight"
        />
    ),
    'Beach - Yellow': (
        <PictogramBeachSmall
            remoteSpriteUrl={PICTOGRAMS_REMOTE_SPRITE_URL}
            backgroundColor="graphicSellingLight"
        />
    ),
    'House - Pink': (
        <PictogramHouseSmall
            remoteSpriteUrl={PICTOGRAMS_REMOTE_SPRITE_URL}
            backgroundColor="graphicBuyingLight"
        />
    ),
    'Hill - Green': (
        <PictogramHillSmall
            remoteSpriteUrl={PICTOGRAMS_REMOTE_SPRITE_URL}
            backgroundColor="graphicPriceLight"
        />
    ),
    'Ferris Wheel - Blue': (
        <PictogramFerrisWheelSmall
            remoteSpriteUrl={PICTOGRAMS_REMOTE_SPRITE_URL}
            backgroundColor="graphicRentingLight"
        />
    ),
    'Thumbs Up - Pink': (
        <PictogramLikedSmall
            remoteSpriteUrl={PICTOGRAMS_REMOTE_SPRITE_URL}
            backgroundColor="graphicBuyingLight"
        />
    )
} as const;

export const mapFromPictogramToIcon = (pictogram: SeoLinkPictograms) => {
    return PictogramsList[pictogram];
};
